// extracted by mini-css-extract-plugin
export default {"root":"Spacer_root__5HETm"};